import React, {Component} from 'react';
import FilterBySalary from 'components/organisms/filter-by-salary';
import FilterByPoints from 'components/organisms/filter-by-points';
import ExposureMode from 'components/molecules/exposure-mode';
import UserPointsType from 'components/molecules/user-points-type';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import SelectOpposingPlayers from 'components/molecules/select-opposing-players';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import SelectSalaryCap from 'components/organisms/select-salary-cap';
import ProjectedOwnershipCap from 'components/organisms/projected-ownership-cap';
import FlexMaxExpPositions from 'components/organisms/flex-max-exp-positions';
import PassReceivers from 'components/molecules/pass-receivers';
import TeamNameStack from 'components/organisms/team-name-stacking/index';
import PlayerPositionStack from 'components/organisms/player-position-stacking/index';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import RangeOfOutcomes from 'components/organisms/range-of-outcomes/range-of-outcomes';
import SelectLineupResolver from 'components/molecules/select-lineup-resolver';
// import CorrelationStacking from 'components/organisms/correlation-stacking';
import OptimizeButton from 'components/molecules/optimize-button';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import ProjectedOwnershipForce from 'components/organisms/projected-ownership-force';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import OptimizeOpener from 'components/molecules/optimize-opener';
import RelaxBuildRules from 'components/molecules/relax-build-rules';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';
import ProjectionBoostRule from 'components/organisms/projection-boost-rule';

class PlayersDashboard extends Component {
    render() {
        return (
            <div>
                {/* <CorrelationStacking /> */}
                <PlayerPositionStack />
                <PlayerGroupingsSwitch openGroupingsLabel="Sim Boost and Player Groupings">
                    <PlayerCombinationStacking />
                    <ProjectionBoostRule />
                </PlayerGroupingsSwitch>
                <TeamNameStack />
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterBySalary useDragging={true} step={1} roundValue={1} />
                            <FilterByPoints useDragging={true} />
                            <SelectSalaryCap step={1} roundValue={1} useDragging={true} />
                            <ProjectedOwnershipCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <UserPointsType
                                options={{
                                    ceilingPoints: 'Ceiling Projection',
                                    adminPoints: 'Projection',
                                }}
                            />
                            <UniquePlayersQuantity />
                            <SelectOpposingPlayers />
                            <SelectLineupResolver />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <FlexMaxExpPositions />
                        </div>
                        <div className="filters-cell">
                            <PassReceivers />
                        </div>
                        <div className="filters-cell">
                            <ProjectedOwnershipForce />
                        </div>
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomes useDragging={true} config={{sport: 'nfl'}} />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                        <RelaxBuildRules className="filters-cell" />
                    </div>
                    <OptimizeButton />
                </div>
            </div>
        );
    }
}

export {PlayersDashboard};
